import clsx from "clsx";
import { avenirNextMedium } from "@/styles/fonts";

type CardButtonProps = {
    textSize?: string;
    paddingY?: string;
    paddingX?: string;
    marginTop?: string;
    width?: string;
};

const cardButtonClass = (props?: CardButtonProps) => {
    const {
        textSize = "text-[17px]",
        paddingY = "py-[10px]",
        paddingX = "px-[16px]",
        marginTop = "mt-[20px]",
        width = "w-[170px]",
    } = props || {};
    return clsx(
        "inline-block",
        "rounded-[6px]",
        paddingY,
        paddingX,
        width,
        marginTop,
        "bg-transparent",
        textSize,
        "border",
        "normal-case",
        avenirNextMedium.className
    );
};

const cardButtonPurpleClass = (props?: CardButtonProps) =>
    clsx(
        cardButtonClass(props),
        "bg-gradient-to-b",
        "from-[#4141f8]",
        "to-[#3838d3]",
        "text-[#fff]",
        "border-[#4141f7]",
        "hover:bg-none",
        "hover:text-[#4141f8]"
    );

const cardButtonBlueClass = (props?: CardButtonProps) =>
    clsx(
        cardButtonClass(props),
        "text-[#2da1f8]",
        "border-[#1585d8]"
    );

export { cardButtonPurpleClass, cardButtonBlueClass };